export const normalizedSportsnewPlacementUserId = value => {
  const number = Number(value);
  return Number.isSafeInteger(number) && number > 0 ? number : null;
};

export const sportsnewPlacementAccountKey = ({ userId = null, generation = 0 } = {}) => (
  `${String(userId ?? '')}:${String(generation)}`
);

export const createSportsnewPlacementAccountIdentity = ({
  userId = null,
  generation = 0,
} = {}) => {
  const normalized = normalizedSportsnewPlacementUserId(userId);
  const normalizedGeneration = Number.isSafeInteger(Number(generation))
    && Number(generation) >= 0
    ? Number(generation)
    : 0;
  const identity = {
    userId: normalized,
    generation: normalizedGeneration,
  };
  return Object.freeze({
    ...identity,
    accountKey: sportsnewPlacementAccountKey(identity),
  });
};

export const nextSportsnewPlacementAccountIdentity = (current, value) => {
  const currentUserId = normalizedSportsnewPlacementUserId(current?.userId);
  const currentGeneration = Number.isSafeInteger(Number(current?.generation))
    && Number(current?.generation) >= 0
    ? Number(current.generation)
    : 0;
  const expectedCurrentKey = sportsnewPlacementAccountKey({
    userId: currentUserId,
    generation: currentGeneration,
  });
  const previous = current?.accountKey === expectedCurrentKey
    ? current
    : createSportsnewPlacementAccountIdentity({
      userId: currentUserId,
      generation: currentGeneration,
    });
  const userId = normalizedSportsnewPlacementUserId(value);
  if (previous.userId === userId) return previous;
  return createSportsnewPlacementAccountIdentity({
    userId,
    generation: previous.generation + 1,
  });
};

export const isSportsnewPlacementAccountIdentityCurrent = (current, guard) => (
  normalizedSportsnewPlacementUserId(guard?.userId) === current?.userId
  && Number(guard?.generation) === Number(current?.generation)
  && guard?.accountKey === current?.accountKey
);

export const createSportsnewPlacementAccountLifecycle = ({ initialIdentity } = {}) => {
  let committed = createSportsnewPlacementAccountIdentity(initialIdentity);
  return Object.freeze({
    commit(userId) {
      committed = nextSportsnewPlacementAccountIdentity(committed, userId);
      return committed;
    },
    capture() {
      return committed;
    },
    isCurrent(guard) {
      return isSportsnewPlacementAccountIdentityCurrent(committed, guard);
    },
  });
};

export const captureSportsnewPlacementPresentationGuard = ({
  attempt,
  identity,
  phase,
} = {}) => Object.freeze({
  userId: Number(attempt?.userId ?? identity?.userId),
  generation: Number(identity?.generation),
  accountKey: identity?.accountKey,
  attemptAccountGeneration: Number(attempt?.accountGeneration),
  idempotencyKey: attempt?.idempotencyKey,
  challenge: attempt?.challenge,
  surface: attempt?.surface,
  phase,
});
